<template>
    <div class="container">
       <div class="headline">Documentation AgriVitech</div>
       <div class="subline">Télécharger les supports de présentation et de formation</div>

       <div class="row">
           
           <div class="col">
          
               <div  class="card">
                   <div class="headline">Application mobile NovaCollecte <img src="@/assets/img/NovaCollecte.png"  class="logoClient" alt="NovaCollecte">  </div>
                   <br>
            
                   <ul class="list-group list-group-flush">
                        <li class="list-group-item headline">
                            <div class="row">
                                <div class="col-2">Version</div>
                                <div class="col-3">Date</div>
                                <div class="col">Commentaire</div>
                                <div class="col-3">Liens</div>
                            </div>
                        </li>
                        <li  class="list-group-item">
                            <div class="row">
                                <div class="col-2">eCotAgri 1.01</div>
                                <div class="col-3">11 Avril 2024</div>
                                <div class="col">Support de formations et d'utilisation de l'application eCotAgri pour Sepac Compagri</div>
                                <div  class="col-3"><a href="./assets/docs/20230411eCotAgriTuto.pdf"><i class="fa fa-download"></i></a></div>
                            </div>
                        </li>
                    </ul>
               </div>

       
     
           </div>
       </div>
   </div>
</template>



<script>
import { store } from '@/router/store'
import router from '@/router/router'
export default {
    name: 'PartHome',
  data() {
      console.log(store.getters.getUser)
    return {
      secretMessage: '',
      username: store.getters.getUser.username,
      company: store.getters.getUser.company,
      first_name: store.getters.getUser.first_name,
      name: store.getters.getUser.name,
      logo: store.getters.getUser.logo,
      demos: store.getters.getUser.demos,
      apps: store.getters.getUser.apps,
      loginBE: '',
      mdpBE:'',
      loginDAP: '',
      mdpDAP:'',
      hasError:false,
      result:''
    };
  },
  methods: {
    logout() {
      store.dispatch('logout');
      router.push('/private');
    }
  },
  beforeUpdate() {
    this.demos = []
    this.apps = []
  },
  updated() {

  }
};
</script>

<style lang="scss" scoped>


a{
    color: var(--mainBlue);
    font-weight: 500;
    &:hover{
        color: var(--mainGreen);
    }
}

.brand{
    font-size: 40px;
    font-weight: 700;
    text-transform: capitalize;
}

.logoutBtn{
    cursor: pointer;
    margin-top: 20px;
    padding-top: 20px;
    border-top: solid 1px #f0f0f0;
    &:hover{
        color: var(--mainGreen);
    }
}

.imgWait{
    max-width: 300px;
    margin-right: auto;
    margin-left: auto;
}

.headline{
    font-size: 30px;
    margin-top: 50px;
    font-weight: 700;
}
.subline{
    font-size: 20px;
    color: var(--mainGreen);
    margin-bottom: 50px;
}

.card{
    border-radius: 10px;
    -webkit-box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    box-shadow: 6px 9px 20px 0px rgba(19, 34, 81, 0.17);
    border: none;
    padding: 15px;
    margin-bottom: 25px;
    .headline{
        font-size: 17px;
        margin-top: 0;
        margin-bottom: 10px;
    }
    .logoClient {
        max-height: 70px;
        position: absolute;
        right: 15px;
        top: 0px;
    }
    .partLogo{
        max-width: 200px;
    }
    .logoApp{
        max-width: 50px;
    }
    .list-group{
        .headline{
            font-size: 13px;
            font-weight: 700;
        }
        &.out{
            color: gray;
        }
    }
    .list-group{
        .headline{
            font-size: 13px;
            font-weight: 700;
        }
        .out{
            color: gray;
            cursor: default;
        }
    }
}
</style>